__turbopack_context__.v({
  "badge": "CartIcon-module__1T5--q__badge",
  "cartButton": "CartIcon-module__1T5--q__cartButton",
  "iconWrap": "CartIcon-module__1T5--q__iconWrap",
  "warningBadge": "CartIcon-module__1T5--q__warningBadge",
});
